export default __webpack_public_path__ + "static/media/3_long.3afb295a.svg";